export const environment = {
  name: 'LOCAL' as 'DEV' | 'QA' | 'PREPROD' | 'LOCAL',
  production: false,
  mscrmappServiceApiUrl: 'https://localhost/',
  isProduction: 'false',
  segmentationMembersApiUrl: 'https://localhost:44389/'
};
